<template>
  <el-dialog title="门诊退费" width="50rem" :visible="visible" :close-on-click-modal="false" @open="open" @close="close"
    append-to-body>
    <el-skeleton v-if="loading" animated />
    <el-main v-if="refundEntity" style="padding: 0 5rem 0 5rem">
      <el-row type="flex" justify="space-around">
        <el-descriptions v-if="reg" title="患者信息" :column="1" style="width: 30%" :contentStyle="{ color: 'orange' }">
          <el-descriptions-item label="姓名">{{ reg.patientName }}</el-descriptions-item>
          <el-descriptions-item label="性别">
            {{ reg.patientGender | dictText("Gender") }}<span class="left-pad" style="color: gray">年龄: </span><span
              class="left-pad">{{ reg.patientAge }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="类别">{{ reg.opType }}</el-descriptions-item>
          <el-descriptions-item label="证件">{{ reg.cardType | dictText("IdType") }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions v-if="refundEntity" title="退费信息" :column="1" style="width: 30%" contentClassName="right"
          :contentStyle="{ color: 'red' }">
          <el-descriptions-item label="费用合计">{{ refundEntity.feeAmount | fmtFloat(2) }}</el-descriptions-item>
          <el-descriptions-item label="基金支付">{{ refundEntity.feeFund | fmtFloat(2) }}</el-descriptions-item>
          <el-descriptions-item label="账户支付">{{ refundEntity.feeAccount | fmtFloat(2) }}</el-descriptions-item>
          <el-descriptions-item label="个人自付">{{ refundEntity.feeCash | fmtFloat(2) }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions v-if="rePayEntity" title="重收信息" :column="1" style="width: 30%" contentClassName="right"
          :contentStyle="{ color: 'red' }">
          <el-descriptions-item label="费用合计">{{ rePayEntity.feeAmount | fmtFloat(2) }}</el-descriptions-item>
          <el-descriptions-item label="基金支付">{{ rePayEntity.feeFund | fmtFloat(2) }}</el-descriptions-item>
          <el-descriptions-item label="账户支付">{{ rePayEntity.feeAccount | fmtFloat(2) }}</el-descriptions-item>
          <el-descriptions-item label="个人自付">{{ rePayEntity.feeCash | fmtFloat(2) }}</el-descriptions-item>
        </el-descriptions>
      </el-row>
      <el-tag v-if="reg.cardType == 'YB'" type="info" effect="plain" style="width: 100%">医保交易流水号：{{ payEntity.insuranceSerialNo }}
      </el-tag>
      <el-divider v-else />
      <el-row v-if="!isNaN(refundValue) && refundValue >= 0" style="margin-top: 1rem">
        <el-col :span="12">
          <div class="flex">
            <span>退费方式：</span>
            <el-select class="edit-input" v-model="refundWay">
              <el-option key="origin" label="原渠道" value="origin" />
              <el-option key="cash" label="现金" value="cash" />
            </el-select>
          </div>
          <div class="flex">
            <span>原发票号：</span>
            <el-tag v-if="payEntity.invoiceNo" type="success" effect="plain" style="font-size: 1rem">{{ payEntity.invoiceNo }}
            </el-tag>
          </div>
        </el-col>
        <el-col :span="12">
          <span class="sub-title">应退费</span><br />
          <strong class="green medium">￥{{ refundEntity.feeCash | fmtFloat(2) }}</strong>
        </el-col>
      </el-row>
      <el-row>
        <el-alert v-if="paying" :closable="false" type="warning" center>退费中 ... <i class="el-icon-loading"></i> </el-alert>
        <el-alert v-if="err" :closable="false" type="error" center>{{ err }}</el-alert>
      </el-row>
    </el-main>

    <el-row type="flex" justify="end" align="middle" slot="footer">
      <el-col :offset="2" :span="10" class="left" v-if="rePayEntity && rePayEntity.feeCash > 0">
        <small>新发票金额：<span style="color: red">{{ rePayEntity.feeCash | fmtFloat(2) }}</span></small>
        <small class="left-pad">新发票：</small>
        <el-switch v-model="isPrint" active-text="打印" inactive-text="不打印" active-color="#13ce66" inactive-color="#ff4949">
        </el-switch>
      </el-col>
      <el-col :span="12">
        <small v-if="isPrint">
          <span v-if="invoiceNo"> 当前发票号：{{ invoiceNo }}</span>
          <span v-else>当前用户名下没有可用发票</span>
        </small>
        <el-button type="default" class="left-pad" @click="close" :loading="submitLoading">取 消</el-button>
        <el-button type="primary" :disabled="isNaN(refundValue) || refundValue < 0" :loading="submitLoading" @click="execRefund">
          退费</el-button>
      </el-col>
    </el-row>
    <med-reader :visible.sync="showMedReader" @ok="medRefund"></med-reader>
  </el-dialog>
</template>

<script>
import api from "./api";
import { mapGetters } from "vuex";
export default {
  props: {
    visible: Boolean,
    payEntity: Object,
  },
  data() {
    return {
      receipt: null,
      refundEntity: {},
      rePayEntity: null,
      refundWay: "origin",
      invoiceNo: null,
      isPrint: false,
      loading: false,
      paying: false,
      err: null,
      submitLoading: false,
      showMedReader: false,
      payWay: 'cash'
    };
  },
  computed: {
    ...mapGetters(["Enum", "user"]),
    reg() {
      return (this?.receipt?.regs ?? [{}])[0];
    },
    refundValue() {
      if (this.rePayEntity) {
        return this?.refundEntity?.feeCash - this.rePayEntity?.feeCash;
      } else {
        return this?.refundEntity?.feeCash;
      }
    },
  },
  create() {
    this.open()
  },
  methods: {
    open() {
      let _this = this;
      this.refundEntity = null
      this.err = null
      this.submitLoading = false
      api
        .invoiceCurrent()
        .then((res) => {
          this.invoiceNo = res;
        })
        .catch((err) => {
          this.$message.error(err);
        });
      this.loading = true
      api
        .rfdQueryPaid(this.payEntity.id)
        .then(res => {
          this.receipt = res
          return api.rfdPrepare(this.payEntity.id, res)
        })
        .then((paraDivide) => {
          paraDivide.receipt = JSON.stringify(this.receipt)
          return api.rfdDivide(paraDivide);
        })
        .then((res) => {
          this.refundEntity = res;
          if (!this.refundEntity.ifDivide) {
            // 已经退过费了，直接更新门诊业务相关表状态
            this.updateOp(this.refundEntity)
          }
        })
        .catch((err) => {
          this.refundEntity = {}
          this.showErr("费用分解失败", err);
        })
        .finally(() => {
          this.loading = false
        });
    },
    async execRefund() {
      if (this.payEntity.fromSys && this.payEntity.fromSys != "sun-his") {
        this.showErr("退款失败", "此收费记录不是从本平台发起的，无法退款。请通过原收费发起平台进行退款！");
        return;
      }
      try {
        await this.$confirm("根据财务规定，您可能需要向患者索取原始发票！确定要执行退款操作吗？", "退款确认");
        if (this.refundWay != "origin" && this.payEntity.payWay != "cash") {
          await this.$confirm("您选择的退款渠道与支付渠道不一致，请再次确认是否执行退款操作？", "退款确认");
        } else {
          this.payWay = this.payEntity.payWay;
        }
        this.submitLoading = true
        this.paying = true;
        if (this.payEntity.ifInsurancePaid) {
          this.showMedReader = true
          return
        }
        const para = { payWay: this.payWay, refundInvoiceNo: this.payEntity.invoiceNo, paymentInvoiceNo: this.invoiceNo }
        this.refundEntity = await api.rfdExec(this.refundEntity.id, para);
        this.$message.success("退款成功!");
      } catch (err) {
        if (err != 'cancel') {
          this.showErr("退款失败！", err);
        }
        return
      } finally {
        this.paying = false;
      }
      this.updateOp()
    },
    async updateOp() {
      // 重要：需要通过receipt，把退款记录和新支付记录返回后端
      try {
        this.receipt.refund = this.refundEntity
        if (this.refundEntity.idNew) {
          this.receipt.payment = await api.getOpPayment(this.refundEntity.idNew)
        }
        await api.rfdUpdate(this.receipt);
        // await api.rfdFinish(this.refundEntity.id);
        this.submitLoading = false
        this.$emit("ok");
        this.$emit("update:visible", false);
      } catch (error) {
        this.showErr("退款成功，状态更新失败！", error);
      }
    },
    showErr(tip, err) {
      if (!err) {
        return;
      }
      this.err = `${tip}。${err.message || err}`;
      console.log(err);
      this.$message.error(this.err);
    },
    close() {
      api.rfdCancel(this.payEntity.patientId).then((res) => {
        this.$emit("update:visible", false);
      });
    },
    // 医保退款
    medRefund(val) {
      console.log('医保退款选择人员信息返回：', val)
      if (!this.payEntity.insuranceSerialNo) {
        this.$message.error('未获取到医保结算编号！')
        return;
      }
      this.medSetlRefund(val.med_code, val).then(res => {
        this.$message.success("医保退款交易成功!");
        const para = {
          payWay: this.payWay,
          refundInvoiceNo: this.payEntity.invoiceNo,
          paymentInvoiceNo: this.invoiceNo,
          feeCash: res.psnCashPay,
          feeAccount: res.acctPay,
          feeFund: res.fundPaySumamt
        }
        return api.rfdExec(this.refundEntity.id, para);
      }).then(res => {
        this.refundEntity = res
        this.updateOp()
        this.$message.success("退款成功!");
      }).catch((err) => {
        this.submitLoading = false
        this.showErr("退款失败！", err);
      }).finally(() => {
        this.paying = false;
      })
    },
    medSetlRefund(med_code, val) {
      const header = {
        insuplc_admdvs: val.insuinfo.insuplc_admdvs,
        ip: val.readCard.ip,
        mac: val.readCard.mac
      }
      return new Promise((resolve, reject) => {
        if (this.payEntity.setlType === this.Enum.SetlType.门诊单据式结算) {
          const para = {
            header: header, input: {
              setlId: this.payEntity.insuranceSerialNo,
              setlIdDelIf: 'false'
            }
          }
          api.medDtRefund(med_code, para).then(res => resolve(res)).catch(err => reject(err))
        } else {
          const para = {
            header: header, input: {
              setlId: this.payEntity.insuranceSerialNo,
            }
          }
          api.medRefund(med_code, para).then(res => resolve(res)).catch(err => reject(err))
        }
      })
    }
  },
};
</script>

<style scoped>
.green {
  color: green;
}

.orange {
  color: orangered;
}

.medium {
  font-size: 3rem;
}

.mini {
  font-size: 0.8rem;
}

.flex {
  width: 15rem;
  display: flex;
  height: 3rem;
  padding: 0rem 2rem 0rem 2rem;
  justify-content: space-between;
  align-items: center;
}

.top-pad {
  margin-top: 0.8rem;
}

.invoice {
  font-size: 1.5rem;
}
</style>
